// src/lib/mixpanel.ts
import mixpanel from 'mixpanel-browser';
import logger from './logger';
import { TELEMETRY_DISABLED } from './config';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || '';
const IS_DEV = import.meta.env.DEV;
const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * Initialize Mixpanel SDK
 * Returns true if initialization was successful, false otherwise
 */
export const initMixpanel = (): boolean => {
  if (TELEMETRY_DISABLED) {
    logger.warn('Mixpanel: telemetry disabled for this environment');
    return false;
  }

  // Debug: Log token status (not the actual token for security)
  logger.log('Mixpanel: Token configured:', !!MIXPANEL_TOKEN, 'Length:', MIXPANEL_TOKEN.length);

  if (!MIXPANEL_TOKEN) {
    logger.warn('Mixpanel: No token configured - analytics disabled');
    return false;
  }

  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: IS_DEV,
      track_pageview: false, // Manual control for page views
      persistence: 'localStorage',
      ignore_dnt: false, // Respect Do Not Track
    });

    // Set environment super property (included with all events)
    const env = IS_DEV ? 'development' : API_URL.includes('staging') ? 'staging' : 'production';

    mixpanel.register({
      app_environment: env,
      app_name: 'Insider Performance',
    });

    logger.log(`Mixpanel initialized for ${env} environment`);
    return true;
  } catch (error) {
    console.error('Mixpanel: Failed to initialize', error);
    return false;
  }
};

/**
 * Check if Mixpanel is initialized and has a valid token
 */
export const isMixpanelEnabled = (): boolean => {
  return Boolean(MIXPANEL_TOKEN) && !TELEMETRY_DISABLED;
};

export { mixpanel };
